import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Property } from "@/types/property";
import PropertyRow from "@/components/v2/molecules/admin/tabs/AdminPropertiesTab/PropertyRow";

interface PropertiesTableProps {
  properties: Property[];
  onEdit: (property: Property) => void;
  onOpenRules: (property: Property) => void;
  onOpenEntry: (property: Property) => void;
  onOpenWifi: (property: Property) => void;
  canDelete: boolean;
}

const PropertiesTable = ({ properties, onEdit, onOpenRules, onOpenEntry, onOpenWifi, canDelete }: PropertiesTableProps) => {
  const tableHeaders = [
    "Nombre",
    "Inicio de Operación",
    "Título",
    "Estatus",
    "Destacada",
    "Características",
    "Ubicación",
    "Acciones",
  ];

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableHead key={header}>{header}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {properties.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center py-8 text-muted-foreground">
                No se encontraron propiedades
              </TableCell>
            </TableRow>
          ) : (
            properties.map((property) => (
              <PropertyRow
                key={property.id}
                property={property}
                onEdit={onEdit}
                onOpenRules={onOpenRules}
                onOpenEntry={onOpenEntry}
                onOpenWifi={onOpenWifi}
                canDelete={canDelete}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default PropertiesTable;